export default {
  askings: [],
  pagination: {},
  asking: {}
}
